import React, { useState, useContext } from "react";
import { View, Text, RadioGroupField, Radio } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router";
import { ProfileDataContext } from "../../contexts/contexts";
import { Icons } from "../../assets/icons";

export function ChooseMaritalStatus() {
  const { setProfileSettingsValues, profileSettingsValues } =
    useContext(ProfileDataContext);

  const [maritalStatus, setMaritalStatus] = useState(
    profileSettingsValues.marital_status
  );

  const navigate = useNavigate();

  function handleMaritalStatus(value) {
    setMaritalStatus(value);
    setProfileSettingsValues((prevData) => ({
      ...prevData,
      marital_status: value,
    }));

    navigate("/lag-profil");
  }

  return (
    <View height="100vh">
      <View
        height="32px"
        backgroundColor="#F3F7F7"
        position="fixed"
        top="0px"
        left="0px"
        right="0px"
        width="100%"
      />
      <View position="fixed" top="32px" left="0px" right="0px" width="100%">
        <View
          height="48px"
          backgroundColor="#F3F7F7"
          width="100%"
          alignItems="center"
          display="flex"
          justifyContent="center"
          position="relative"
        >
          <Text textAlign={"center"} color={"#29666A"} fontSize="16px">
            Samlivsform
          </Text>

          <img
            onClick={() => navigate("/lag-profil")}
            style={{ position: "absolute", right: "16px", bottom: "5px" }}
            src={Icons.cancel}
            alt="cancel"
          />
        </View>
      </View>

      <View
        paddingTop="60px"
        margin="0 16px 0 16px"
        display="flex"
        justifyContent="space-between"
        direction="column"
        alignItems="center"
        height={"100vh"}
      >
        <View width="100%">
          <RadioGroupField
            marginTop={"40px"}
            width="100%"
            height={"48px"}
            backgroundColor={"#F9FBFB"}
            borderRadius="4px"
            justifyContent={"flex-start"}
            direction="row"
            alignItems="center"
          >
            <Radio
              readOnly={true}
              checked={maritalStatus === "Singel" ? true : false}
              onClick={() => handleMaritalStatus("Singel")}
              value={""}
              width={"100%"}
            >
              <Text marginLeft={"5px"} fontSize="16px" color="#43898E">
                Singel
              </Text>
            </Radio>
          </RadioGroupField>
          <RadioGroupField
            marginTop={"24px"}
            width="100%"
            height={"48px"}
            backgroundColor={"#F9FBFB"}
            borderRadius="4px"
            justifyContent={"flex-start"}
            direction="row"
            alignItems="center"
          >
            <Radio
              readOnly={true}
              checked={
                maritalStatus === "Parforhold / romantisk partner"
                  ? true
                  : false
              }
              onClick={() =>
                handleMaritalStatus("Parforhold / romantisk partner")
              }
              value=""
              width={"100%"}
            >
              <Text marginLeft={"5px"} fontSize="16px" color="#43898E">
                Parforhold / romantisk partner
              </Text>
            </Radio>
          </RadioGroupField>

          <RadioGroupField
            marginTop={"24px"}
            width="100%"
            height={"48px"}
            backgroundColor={"#F9FBFB"}
            borderRadius="4px"
            justifyContent={"flex-start"}
            direction="row"
            alignItems="center"
          >
            <Radio
              readOnly={true}
              checked={maritalStatus === "Gift" ? true : false}
              onClick={() => handleMaritalStatus("Gift")}
              value=""
              width={"100%"}
            >
              <Text marginLeft={"5px"} fontSize="16px" color="#43898E">
                Gift
              </Text>
            </Radio>
          </RadioGroupField>

          <RadioGroupField
            marginTop={"24px"}
            width="100%"
            height={"48px"}
            backgroundColor={"#F9FBFB"}
            borderRadius="4px"
            justifyContent={"flex-start"}
            direction="row"
            alignItems="center"
            marginBottom={"53px"}
          >
            <Radio
              readOnly={true}
              checked={maritalStatus === "Annet" ? true : false}
              onClick={() => handleMaritalStatus("Annet")}
              value=""
              width={"100%"}
            >
              <Text marginLeft={"5px"} fontSize="16px" color="#43898E">
                Annet
              </Text>
            </Radio>
          </RadioGroupField>
        </View>

        {/* <SecondaryButton
          onClick={() => handleApplyMaritalStatus()}
          marginTop={"56px"}
          marginBottom="77px"
          overrides={{
            label: {
              children: "Legg til",
            },
          }}
        /> */}
      </View>
    </View>
  );
}
